












helpers = require('../../../helpers.coffee')

view_model =
  components:
    pipedrive: require './pipedrive.vue'
    rdStation: require './rd_station.vue'
    rdStationCrm: require './rd_station_crm.vue'
    salesforce: require './salesforce.vue'
    hubspot: require './hubspot.vue'
    cvCrm: require './cv_crm.vue'

  data: ->
    current_user: Session.current_user
    setting: ''

  computed:
    is_pipedrive: ->
      @setting == 'pipedrive'

    is_rd_station: ->
      @setting == 'rd_station'

    is_rd_station_crm: ->
      @setting == 'rd_station_crm'

    is_salesforce: ->
      @setting == 'salesforce'

    is_hubspot: ->
      @setting == 'hubspot'

    is_cv_crm: ->
      @setting == 'cv_crm'

  mounted: ->
    @setting = @$router.currentRoute.query.setting

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/index.vue